import apiClient from "../api-client";
import {
  API_ENDPOINT_ADD_ACCOUNT,
  API_ENDPOINT_UPDATE_ACCOUNT,
} from "../endpoint-urls";

export interface IRgba {
  r: number;
  g: number;
  b: number;
  a: number;
}

interface IBankAccount {
  account: string;
  name: string;
  bank?: string;
  number?: string;
  currency: string;
  settings?: {
    bg: IRgba | "";
    color: IRgba | "";
    disabled?: boolean;
    picture?: any;
  };
  logo?: any;
}

export const registerBankAccount = async ({
  account,
  name,
  bank,
  number,
  currency,
  settings = {
    color: "",
    bg: "",
    disabled: false,
  },
  logo = null,
}: IBankAccount) => {
  const params = new FormData();

  params.append(
    "params",
    JSON.stringify({
      account,
      name,
      bank,
      number,
      currency,
      settings,
    }),
  );

  if (logo) {
    params.append("logo", logo || "");
  }

  return await apiClient
    .post(API_ENDPOINT_ADD_ACCOUNT, params, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(async () => {
      return {
        success: true,
      };
    })
    .catch((e: any) => {
      return {
        success: false,
        error: e,
      };
    });
};

export const updateBankAccount = async ({
  account,
  name,
  bank,
  number,
  currency,
  settings = {
    color: "",
    bg: "",
    disabled: false,
    picture: "",
  },
  logo = null,
}: IBankAccount) => {
  const params = new FormData();

  params.append(
    "params",
    JSON.stringify({
      account,
      name,
      bank,
      number,
      currency,
      settings,
    }),
  );

  if (logo) {
    params.append("logo", logo || "");
  }

  return await apiClient
    .put(API_ENDPOINT_UPDATE_ACCOUNT, params, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(async () => {
      return {
        success: true,
      };
    })
    .catch((e: any) => {
      return {
        success: false,
        error: e,
      };
    });
};
